import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FieldWrapper } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { FieldsetAriaFixDirective } from '@shared/directives/fieldset-area-fix.directive';
import { FieldsetModule } from 'primeng/fieldset';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-formly-fieldset',
  template: `
      <p-fieldset [id]="elementId" [styleClass]="className" fieldsetAriaFix>
      <p-header>
        <span [innerHTML]="label | translate"></span>{{number}}{{starChar}}
        <fa-icon
         *ngIf="props.icon"
          pTooltip="{{props.icon?.text | translate}}"
          tooltipStyleClass="tooltip-min-width"
          [escape]="false"
          tooltipPosition="top"
          [icon]="['fas', 'info-circle']">
        </fa-icon>  
      </p-header>
        <ng-container #fieldComponent></ng-container>
      </p-fieldset>
`,
  styleUrls: ['./formly-fieldset.component.scss'],
  imports: [FieldsetModule, TranslateModule, CommonModule, TooltipModule, FontAwesomeModule,
    FieldsetAriaFixDirective ]
})
export class FormlyFieldsetComponent extends FieldWrapper implements OnInit{

  translatePrefix: string;
  className: string;
  starChar

  constructor() {
    super();
  }

  get elementId(): string {
    if (this.field.id && this.field.id.includes('formly_')) {
      let prefix = this.form['id'];

      // check if in repeat section
      if (!prefix && this.field.parent.parent && this.field.parent.parent.parent && this.field.parent.parent.parent.type === 'repeat') {
        const cnt = this.field.parent.parent.key;
        prefix = `${this.field.parent.parent.parent['id']}_${cnt}`;
      }

      if(this.field.wrappers.length >= 0 )
        return this.field.id
      
      return `${prefix ? prefix + '_' : ''}${(this.key as string).replace('.', '_')}`;

    } else {
      return this.field.id;
    }
  }

  ngOnInit() {
    this.translatePrefix = this.props.translatePrefix ? `${ this.props.translatePrefix }.` : '';
    this.className = this.props.className || '';
  }

  get label() {
    const starChar = this.props.label.charAt(this.props.label.length-1);
    let label = this.props.label;
    if (starChar === '*') {
      this.starChar = starChar;
      label = this.props.label.slice(0,this.props.label.length-1);
    }
    return `${ this.translatePrefix }${ label }`;
  }
  get number() {
    if (this.props.includeNumber) {
      return this.field.parent.key ? ' ' + (parseInt(this.field.parent.key as string, 10) + 1) : '';
    } else {
      return '';
    }
  }

}
